module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKBAMAAABlIDIAAAAAGFBMVEUAAAAXFxcZGRkYGBgZGRkaGhoZGRkZGRmH+95GAAAACHRSTlMAIjOImard7os+9vEAAAAmSURBVAjXYzBiYGBwV2BgYCmCMlgLGRjUHRiYSsAUQwpQWICBAQBMKQOlzI2F5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/arrow_right.png
// module id = 666
// module chunks = 0